// src/pages/Home.js (Simplified - No Filtering)
import React from "react";
import VideoCarousel from "../components/VideoCarousel";
import ProjectGrid from "../components/ProjectGrid";
import { getFeaturedProjects, getGridProjects } from "../data/projects";

// Flip to true to bring the hero video carousel back
const SHOW_HERO = false;

const Home = () => {
  // Get featured projects for the carousel
  const carouselData = getFeaturedProjects();

  // Get projects for the grid
  // Projects listed first (in this order); the rest stay sorted by date
  const pinnedFirst = ["twomoons"];
  const projectsData = getGridProjects().sort((a, b) => {
    const ai = pinnedFirst.indexOf(a.id);
    const bi = pinnedFirst.indexOf(b.id);
    return (ai === -1 ? Infinity : ai) - (bi === -1 ? Infinity : bi) || 0;
  });

  return (
    <div
      className="px-6 pt-24 md:pt-44"
      style={{
        // Shared width for the hero and grid: sized so header + hero fit on screen
        "--content-w": "clamp(720px, calc((100vh - 13rem) * 16 / 9), 1154px)",
      }}
    >
      {SHOW_HERO && <VideoCarousel slides={carouselData} />}
      <ProjectGrid projects={projectsData} />
    </div>
  );
};

export default Home;
